import { ColumnFilterDisplay } from '@app/modules/table/types/column-filter-display.type';
import { FilterValue } from '@app/modules/table/types/filter-value.type';
import { TranslatableKey } from '@app/types/translatable.type';
import { Filter } from '../../filter.abstract';
import { ColumnFilter } from '../column-filter.abstract';

export const isRadioButtonFilter = (filter: Filter): filter is RadioButtonFilter => filter.type === 'radio';

type RadioItem = {
    value: FilterValue;
    label: TranslatableKey;
    initiallyActive?: boolean;
};

export class RadioButtonFilter extends ColumnFilter {
    type: ColumnFilterDisplay = 'radio';
    selected: RadioItem['value'] = null;
    nullable = true;

    constructor(
        protected filterField: string,
        public readonly options: RadioItem[],
        label?: string
    ) {
        super();

        this.label = label;

        const initiallySelected = options.find((option) => option.initiallyActive);

        if (initiallySelected) {
            this.selected = initiallySelected.value;
        }

        this.isReady = true;
    }

    clear(): void {
        if (this.selected === null) {
            return;
        }
        this.selected = null;
        this.emitChanges();
    }

    hasValues(): boolean {
        return !!this.selected;
    }

    isActive(option: RadioItem): boolean {
        return option.value === this.selected;
    }

    changeValue(option: RadioItem): void {
        this.selected = option.value;
        this.emitChanges();
    }

    private emitChanges(): void {
        this.onChanges.next([
            {
                field: this.filterField,
                value: this.selected !== null ? this.selected : null,
            },
        ]);
    }
}
